<template>
  <q-form ref="editForm">
    <!-- 일반작업 상세정보 -->
    <c-card title="LBL0000315" class="cardClassDetailForm no-margin">
      <template slot="card-detail">
        <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4">
          <!-- 작업개요 -->
          <c-text
            :required="true"
            :disabled="!isWriting"
            :editable="editable"
            label="LBL0000211"
            name="workSummary"
            v-model="workPermit.workSummary"
          >
          </c-text>
        </div>
        <div class="col-xs-6 col-sm-4 col-md-2 col-lg-2">
          <!-- 단위공정 -->
          <c-process
            :disabled="!isWriting"
            :editable="editable"
            label="LBL0000222"
            name="processCd"
            v-model="workPermit.processCd"
          >
          </c-process>
        </div>
        <div class="col-xs-6 col-sm-4 col-md-2 col-lg-2">
          <!-- 작업명 -->
          <c-text
            :editable="editable"
            :disabled="!isWriting"
            label="LBL0000223"
            name="sopName"
            v-model="workPermit.sopName"
          >
          </c-text>
        </div>
        <div class="col-xs-6 col-sm-4 col-md-2 col-lg-2">
          <!-- 작업장소 -->
          <c-text
            :disabled="!isWriting"
            :editable="editable"
            label="LBL0000225"
            name="workLocation"
            v-model="workPermit.workLocation"
          >
          </c-text>
        </div>
        <div class="col-xs-6 col-sm-4 col-md-2 col-lg-2">
          <!-- 신청인 -->
          <c-text
            :disabled="true"
            :editable="editable"
            label="LBL0000229"
            name="request"
            v-model="request"
          >
          </c-text>
        </div>
        <div class="col-xs-6 col-sm-4 col-md-2 col-lg-2">
          <!-- 작업업체 -->
          <c-vendor
            :disabled="!isWriting"
            :editable="editable"
            label="LBL0000224"
            name="vendorCd"
            v-model="workPermit.vendorCd"
            @dataChange="vendorChange"
          />
        </div>
        <div class="col-xs-6 col-sm-4 col-md-2 col-lg-2">
          <c-text
            :disabled="true"
            :editable="editable"
            label="작업업체 사업자등록번호"
            name="bizNo"
            v-model="workPermit.bizNo"
          >
          </c-text>
        </div>
        <div class="col-xs-6 col-sm-4 col-md-2 col-lg-2">
          <c-text
            phoneNumberCheck
            :disabled="!isWriting"
            :editable="editable"
            label="작업업체 책임자 HP"
            name="vendorResponseUserName"
            v-model="workPermit.vendorResponseUserName"
          >
          </c-text>
        </div>
        <div class="col-xs-6 col-sm-4 col-md-2 col-lg-2">
          <c-text
            :disabled="!isWriting"
            :editable="editable"
            label="상주관리자"
            name="residentManagerName"
            v-model="workPermit.residentManagerName"
          >
          </c-text>
        </div>
        <div
          v-if="!isVendorReqeust"
          class="col-xs-6 col-sm-4 col-md-2 col-lg-2"
        >
          <!-- 관련 설비 -->
          <c-equip
            :disabled="!isWriting"
            :editable="editable"
            :plantCd="workPermit.plantCd"
            :processCd="workPermit.processCd"
            label="LBL0000227"
            name="equipmentCd"
            v-model="workPermit.equipmentCd"
          >
          </c-equip>
        </div>
        <div class="col-xs-6 col-sm-4 col-md-2 col-lg-2">
          <c-field
            :required="true"
            :disabled="!isWriting"
            :editable="editable"
            type="dept_user"
            userType="lnf"
            label="LBLMANAGER"
            name="workManagerId"
            v-model="workPermit.workManagerId"
          />
        </div>
        <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
          <!-- 보호구 -->
          <c-checkbox
            :disabled="!isWriting"
            :editable="editable"
            codeGroupCd="SOP_PROTECTIVE_GEAR_CD"
            :isObject="true"
            valueText="sopProtectiveGearName"
            valueKey="sopProtectiveGearCd"
            label="LBL0000231"
            name="protectiveGears"
            v-model="workPermit.protectiveGears"
          />
        </div>
        <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
          <!-- 특별요구사항 -->
          <c-textarea
            :disabled="!isWriting"
            :editable="editable"
            :rows="2"
            label="LBL0000230"
            name="specialRequirements"
            v-model="workPermit.specialRequirements"
          >
          </c-textarea>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
          <c-textarea
            :disabled="!isWriting"
            :editable="editable"
            :rows="2"
            label="공사내용"
            name="construnctionDetails"
            v-model="workPermit.construnctionDetails"
          >
          </c-textarea>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4">
          <!-- 관련공사 -->
          <c-construnction
            :disabled="!isWriting"
            :editable="editable"
            name="sopConstructionId"
            v-model="workPermit.sopConstructionId"
          >
          </c-construnction>
        </div>
      </template>
    </c-card>
    <div class="row">
      <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3">
        <!-- 안전조치 요구사항 -->
        <!-- class="q-mt-md" -->
        <c-table
          title="LBL0000232"
          gridHeightAuto
          :columns="grid.columns"
          :data="workPermit.checkResults"
          :filtering="false"
          :columnSetting="false"
          :usePaging="false"
          :editable="editable && isWriting"
          :contentsField="contentsField"
          @table-data-change="tableDataChange"
        >
        </c-table>
        <c-table
          title="장비 대여"
          :columns="gridEquipRent.columns"
          gridHeightAuto
          :data="workPermit.equipRents"
          :filtering="false"
          :columnSetting="false"
          :usePaging="false"
          :editable="editable && isWriting"
        >
          <template v-slot:customArea="{ props, col }">
            <template v-if="props.row.requestFlag === 'Y'">
              <c-number-column
                :editable="editable && isWriting"
                :col="col"
                :props="props"
                v-model="props.row[col.name]"
                @datachange="datachange(props)"
              />
            </template>
          </template>
        </c-table>
      </div>
      <div class="col-xs-12 col-sm-12 col-md-9 col-lg-9">
        <div class="row">
          <div class="col-xs-4 col-sm-4 col-md-4 col-lg-4">
            <!-- 발급 정보 -->
            <c-card title="LBL0000241" class="cardClassDetailForm no-margin">
              <template slot="card-detail">
                <div class="col-12">
                  <!-- 발급 -->
                  <c-field
                    :required="true"
                    :disabled="!isWriting"
                    :editable="editable"
                    :data="workPermit"
                    deptValue="issuedDeptCd"
                    type="dept_user"
                    label="LBL0000242"
                    name="issuedUserId"
                    v-model="workPermit.issuedUserId"
                  />
                </div>
                <div class="col-12">
                  <!-- 승인 -->
                  <c-field
                    :required="true"
                    :disabled="!isWriting"
                    :editable="editable"
                    :data="workPermit"
                    deptValue="approvalDeptCd"
                    type="dept_user"
                    label="LBL0000243"
                    name="approvalUserId"
                    v-model="workPermit.approvalUserId"
                  />
                </div>
              </template>
            </c-card>
          </div>
          <div class="col-xs-4 col-sm-4 col-md-4 col-lg-4">
            <!-- 협조자 정보 -->
            <c-card title="LBL0000244" class="cardClassDetailForm no-margin">
              <template slot="card-detail">
                <!-- 협조자-1 -->
                <div class="col-12">
                  <c-field
                    :disabled="!isWriting"
                    :editable="editable"
                    :data="workPermit"
                    deptValue="relationCooperation1DeptCd"
                    type="dept_user"
                    label="LBL0000245"
                    name="relationCooperation1UserId"
                    v-model="workPermit.relationCooperation1UserId"
                  />
                </div>
                <div class="col-12">
                  <!-- 협조자-2 -->
                  <c-field
                    :disabled="!isWriting"
                    :editable="editable"
                    :data="workPermit"
                    deptValue="relationCooperation2DeptCd"
                    type="dept_user"
                    label="LBL0000246"
                    name="relationCooperation2UserId"
                    v-model="workPermit.relationCooperation2UserId"
                  />
                </div>
              </template>
            </c-card>
          </div>
          <div class="col-xs-4 col-sm-4 col-md-4 col-lg-4">
            <!-- 안전조치확인 정보 -->
            <c-card title="LBL0000247" class="cardClassDetailForm no-margin">
              <template slot="card-detail">
                <div class="col-12">
                  <!-- 책임자 -->
                  <c-field
                    :disabled="!isWriting"
                    :editable="editable"
                    :data="workPermit"
                    deptValue="maintenanceDeptCheckDeptCd"
                    type="dept_user"
                    label="LBL0000248"
                    name="maintenanceDeptCheckUserId"
                    v-model="workPermit.maintenanceDeptCheckUserId"
                  />
                </div>
                <div class="col-12">
                  <!-- 입회자 -->
                  <c-field
                    :disabled="!isWriting"
                    :editable="editable"
                    :data="workPermit"
                    deptValue="maintenanceDeptEntryDeptCd"
                    type="dept_user"
                    label="LBL0000249"
                    name="maintenanceDeptEntryUserId"
                    v-model="workPermit.maintenanceDeptEntryUserId"
                  />
                </div>
              </template>
            </c-card>
          </div>
          <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
            <!-- 가스농도 측정 -->
            <!-- class="q-mt-md" -->
            <c-table
              ref="gasTable"
              title="LBL0000236"
              :columns="grid2.columns"
              :gridHeight="grid2.height"
              :data="workPermit.gases"
              :filtering="false"
              :columnSetting="false"
              :usePaging="false"
              :editable="editable && isWriting"
              selection="multiple"
              rowKey="sopGasCheckId"
            >
              <!-- <template slot="customTableTitleEditor">
                <q-card class="custom-card no-margin" flat bordered>
                  <q-card-section horizontal class="cardhead bg-grey-3">
                    <q-card-section class="q-pa-xs">
                      <div class="gas-card-title text-grey-8" style="display:inline;">가스점검</div>
                      <div class="text-caption text-grey q-pl-xs" style="display:inline;">
                        가스농도 측정에 필요한 기기와 점검/확인자를 지정하세요.
                      </div>
                    </q-card-section>
                  </q-card-section>

                  <q-separator />

                  <q-card-actions>
                    <div class="col-4 gas-item">
                      <c-text
                        :editable="editable"
                        label="점검기기명"
                        name="col1"
                        v-model="workPermit.col1">
                      </c-text>
                    </div>
                    <div class="col-4 gas-item">
                      <c-text
                        :editable="editable"
                        label="점검자"
                        name="col1"
                        v-model="workPermit.col1">
                      </c-text>
                    </div>
                    <div class="col-4 gas-item">
                      <c-text
                        :editable="editable"
                        label="확인자(입회자)"
                        name="col1"
                        v-model="workPermit.col1">
                      </c-text>
                    </div>
                  </q-card-actions>
                </q-card>
              </template> -->
              <template slot="table-button">
                <q-btn-group outline>
                  <!-- 추가 -->
                  <c-btn
                    v-if="editable && isWriting"
                    label="LBL0000253"
                    icon="add"
                    :showLoading="false"
                    @btnClicked="addGas"
                  />
                  <!-- 제외 -->
                  <c-btn
                    v-if="editable && isWriting"
                    label="LBL0000275"
                    icon="remove"
                    :showLoading="false"
                    @btnClicked="removeGas"
                  />
                </q-btn-group>
              </template>
            </c-table>
          </div>
        </div>
      </div>
    </div>
    <c-dialog :param="popupOptions"></c-dialog>
  </q-form>
</template>

<script>
import { uid } from "quasar";
import eventBus from "@/js/eventBus";
import selectConfig from "@/js/selectConfig";
export default {
  name: "swp-normal",
  props: {
    workPermit: {
      type: Object,
      default: function () {
        return {
          sopWorkPermitId: "", // 작업허가서 일련번호
          plantCd: "", // 사업장 코드
          sopName: "", // 작업명
          mdmSopId: "", // 안전작업 표준 일련번호_SOP에서 불러와서 관련 정보 표시후 수정
          permitNo: "", // 허가번호_(YYYYMMDD-01)
          swpStepCd: "", // 진행단계 코드
          applicationDeptCd: "", // 신청인 부서코드
          applicationDeptName: "",
          applicationUserId: "", // 신청인 ID
          applicationUserName: "",
          permitTypeCd: "", // 허가서 구분_화기/일반
          permitDate: "", // 허가일
          workStartTime: "", // 작업시작시간
          workEndTime: "", // 작업종료시간
          workTime: [], // 작업시간
          processCd: "", // 작업공정
          workLocation: "", // 작업장소
          equipmentCd: "", // 설비번호_설비마스터
          workSummary: "", // 작업개요
          specialRequirements: "", // 특별요구사항
          maintenanceDeptCheckUserId: "", // 정비부서 책임자 - 안전조치확인
          maintenanceDeptEntryUserId: "", // 정비부서 입회자 - 안전조치확인
          workCompleteTime: "", // 작업완료시간
          workCompleteEntryUserId: "", // 작업완료 입회자/확인자
          workCompleteWorkUserId: "", // 작업완료 작업자
          issuedDeptCd: "", // 발급자 부서코드
          issuedUserId: "", // 발급자 ID
          approvalDeptCd: "", // 승인자 부서코드
          approvalUserId: "", // 승인자 ID
          relationCooperation1DeptCd: "", // 관련부서 협조자1 부서코드
          relationCooperation1UserId: "", // 관련부서 협조자1 ID
          relationCooperation2DeptCd: "", // 관련부서 협조자2 부서코드
          relationCooperation2UserId: "", // 관련부서 협조자2 ID
          vendorCd: "", // 작업업체 코드
          bizNo: "",
          vendorResponseUserName: "", // 작업업체 책임자
          residentManagerName: "", // 상주관리자
          construnctionDetails: "", // 공사내용
          lotoApplyArea: "", // LOTO 적용구역
          overWorkFlag: "", // 연장작업 여부
          vendorFlag: 0, // 업체작성여부
          psmFlag: "N", // PSM 관련 여부
          sopMocId: "", // MOC 일련번호
          assessWriteUserId: "", // 작업위험성평가_작성자 ID
          assessApprovalUserId: "", // 작업위험성평가_승인자 ID
          sopConstructionId: "",
          regUserId: "", // 등록자 ID
          chgUserId: "", // 수정자 ID
          supWorks: [],
          deleteSupWorks: [],
          checkResults: [],
          deleteCheckResults: [],
          equipRents: [],
          gases: [],
          gasChecks: [], // 저장용
          gasCheckVals: [], // 저장용
          deleteGasChecks: [],
          deleteGasCheckVals: [],
          maps: [],
          deleteMaps: [],
          workers: [],
          deleteWorkers: [],
          assessments: [],
          deleteAssessments: [],
          overs: [],
          deleteOvers: [],
          protectiveGears: [],
          deleteProtectiveGears: [],
        };
      },
    },
    isOld: {
      type: Boolean,
      default: false,
    },
    isWriting: {
      type: Boolean,
      default: false,
    },
    saveCall: {
      type: Object,
      default: function () {
        return {
          saveCallData: "",
        };
      },
    },
  },
  data() {
    return {
      grid: {
        columns: [],
        data: [],
      },
      grid2: {
        columns: [],
        height: "382px",
      },
      gridEquipRent: {
        columns: [
          {
            name: "equipmentName",
            field: "equipmentName",
            label: "장비명",
            style: "width:150px",
            align: "center",
            sortable: false,
          },
          {
            name: "requestFlag",
            field: "requestFlag",
            label: "신청<br/>여부",
            style: "width:45px",
            align: "center",
            sortable: false,
            type: "check",
            true: "Y",
            false: "N",
            value: "N",
            setHeader: true,
          },
          {
            name: "requestCount",
            field: "requestCount",
            label: "신청<br/>수량",
            style: "width:60px",
            align: "right",
            type: "custom",
            sortable: false,
          },
          {
            name: "rentFlag",
            field: "rentFlag",
            label: "대여<br/>여부",
            style: "width:45px",
            align: "center",
            type: "check",
            true: "Y",
            false: "N",
            sortable: false,
            disableTarget: "none",
            disableCon: "Y",
          },
          {
            name: "returnFlag",
            field: "returnFlag",
            label: "반납<br/>여부",
            style: "width:45px",
            align: "center",
            type: "check",
            true: "Y",
            false: "N",
            sortable: false,
            disableTarget: "none",
            disableCon: "Y",
          },
        ],
        height: "400px",
      },
      useGasItems: [],
      editable: true,
      listCheckItemUrl: "",
      listGasItemUrl: "",
      listEquipRentUrl: "",
      popupOptions: {
        target: null,
        title: "",
        visible: false,
        width: "90%",
        top: "10px",
        param: {},
        closeCallback: null,
      },
    };
  },
  computed: {
    request() {
      return this.isVendorReqeust
        ? this.workPermit.applicationDeptName
        : this.workPermit.applicationDeptName +
            " / " +
            this.workPermit.applicationUserName;
    },
    isVendorReqeust() {
      return this.workPermit.vendorFlag > 0;
    },
  },
  watch: {
    "workPermit.plantCd"() {
      this.$set(this.workPermit, "checkResults", []);
      this.$set(this.workPermit, "gases", []);
      this.getCheckItemList();
      this.getGasItemList();
    },
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    eventBus.$on("vaildForm", (type) => {
      if (this.$refs["editForm"]) {
        this.$refs["editForm"].validate().then((_result) => {
          this.$emit("validResult", _result, type);
        });
      }
    });
    this.init();
  },
  beforeDestroy() {},
  methods: {
    init() {
      // role setting
      this.editable = this.$route.meta.editable;
      // url setting
      this.listCheckItemUrl = selectConfig.sop.swp.workChekItem.list.url;
      this.listGasItemUrl = selectConfig.sop.swp.gas.list.url;
      this.listEquipRentUrl = selectConfig.sop.swp.workPermit.base.url;
      // code setting
      // list setting
      this.getCheckItemList();
      this.getGasItemList();
      this.getEquipRents();
    },
    getCheckItemList() {
      /**
       * default 값을 조회
       *
       * 초기인 경우 workPermit.checkResults에 값을 그대로 적용
       * 작성중 단계인 경우 default 값에 새로운 항목이 있을시에 workPermit.checkResults에 추가하여 입력을 받을 수 있도록 조치
       * 승인완료, 연장, 취소, 작업완료인 경우 저장된 데이터를 그대로 표시하며 이 경우 default값을 조회하지 않도록 조치
       */
      this.grid.columns = [
        // 항목
        {
          name: "checkItemName",
          field: "checkItemName",
          label: "LBL0000233",
          align: "left",
          sortable: true,
        },
        // 필요
        {
          name: "necessaryFlag",
          field: "necessaryFlag",
          label: "LBL0000234",
          align: "center",
          sortable: false,
          type: "check",
          true: "Y",
          false: "N",
          value: "N",
          setHeader: true,
        },
        // 확인
        {
          name: "confirmFlag",
          field: "confirmFlag",
          label: "LBL0000235",
          align: "center",
          sortable: false,
          type: "check",
          disableTarget: "necessaryFlag",
          disableCon: "Y",
          true: "Y",
          false: "N",
          value: "N",
          setHeader: true,
        },
      ];
      if (!this.workPermit.plantCd) return;
      if (!this.workPermit.checkResults) this.workPermit.checkResults = [];
      if (!this.isOld || this.workPermit.swpStepCd === "SS00000001") {
        this.$http.url = this.listCheckItemUrl;
        this.$http.type = "GET";
        this.$http.param = {
          plantCd: this.workPermit.plantCd,
          sopWorkTypeCd: "SWT0000001",
          useFlag: "Y",
        };
        this.$http.request((_result) => {
          if (
            !this.isOld &&
            (!this.workPermit.checkResults ||
              this.workPermit.checkResults.length === 0)
          ) {
            // 최초인 경우 조치항목을 가지고 있지 않음으로 해당 값을 표시
            this.$_.forEach(_result.data, (item) => {
              this.workPermit.checkResults.push({
                sopWorkPermitId: "", // 작업허가서 일련번호
                supplementWorkTypeCd: "", // 보충작업구분
                sopCheckItemId: item.sopCheckItemId, // 점검항목 일련번호
                checkItemName: item.checkItemName, // 점검항목명
                sopCheckItemKindCd: item.sopCheckItemKindCd, // 체크항목 종류
                necessaryFlag: "N", // 필요
                confirmFlag: "N", // 확인
                confirmUserId: "", // 확인자
                confirmUserName: "", // 확인자명
                regUserId: this.$store.getters.user.userId, // 등록자 ID
                chgUserId: "", // 수정자 ID
                editFlag: "C",
              });
            });
          } else {
            this.$_.forEach(_result.data, (item) => {
              if (
                this.$_.findIndex(this.workPermit.checkResults, {
                  sopCheckItemId: item.sopCheckItemId,
                }) === -1
              ) {
                this.workPermit.checkResults.push({
                  sopWorkPermitId: this.workPermit.sopWorkPermitId, // 작업허가서 일련번호
                  supplementWorkTypeCd: "", // 보충작업구분
                  sopCheckItemId: item.sopCheckItemId, // 점검항목 일련번호
                  checkItemName: item.checkItemName, // 점검항목명
                  sopCheckItemKindCd: item.sopCheckItemKindCd, // 체크항목 종류
                  necessaryFlag: "N", // 필요
                  confirmFlag: "N", // 확인
                  confirmUserId: "", // 확인자
                  confirmUserName: "", // 확인자명
                  regUserId: this.$store.getters.user.userId, // 등록자 ID
                  chgUserId: "", // 수정자 ID
                  editFlag: "C",
                });
              }
            });
          }
          // 확인자
          if (
            this.$_.findIndex(_result.data, {
              sopCheckItemKindCd: "SCIK000005",
            }) > -1 ||
            this.$_.findIndex(this.workPermit.checkResults, {
              sopCheckItemKindCd: "SCIK000005",
            }) > -1
          ) {
            this.grid.columns.push({
              name: "confirmUserName",
              field: "confirmUserName",
              label: "LBL0000240",
              align: "center",
              sortable: true,
              type: "user",
              userId: "confirmUserId",
              disableTarget: "necessaryFlag",
              disableCon: "Y",
            });
          }
        });
        // 확인자
      } else {
        if (
          this.$_.findIndex(this.workPermit.checkResults, {
            sopCheckItemKindCd: "SCIK000005",
          }) > -1
        ) {
          this.grid.columns.push({
            name: "confirmUserName",
            field: "confirmUserName",
            label: "LBL0000240",
            align: "center",
            sortable: true,
            type: "user",
            userId: "confirmUserId",
            disableTarget: "necessaryFlag",
            disableCon: "Y",
          });
        }
      }
    },
    getGasItemList() {
      let columns = [
        // 점검시간
        {
          name: "checkTime",
          field: "checkTime",
          label: "LBL0000237",
          align: "center",
          type: "datetime",
          minuteStep: 10,
          sortable: false,
          style: "width:15%",
        },
        // 점검기기
        {
          name: "gasCheckMachine",
          field: "gasCheckMachine",
          label: "LBL0000238",
          align: "center",
          sortable: false,
          type: "text",
          value: "",
          setHeader: true,
          style: "width:15%",
        },
        // 점검자
        {
          name: "gasCheckUserName",
          field: "gasCheckUserName",
          label: "LBL0000239",
          align: "center",
          sortable: false,
          type: "user",
          userId: "gasCheckUserId",
          value: "",
          setHeader: true,
          style: "width:10%",
        },
        // 확인자
        {
          name: "gasConfirmUserName",
          field: "gasConfirmUserName",
          label: "LBL0000240",
          align: "center",
          sortable: false,
          type: "user",
          userId: "gasConfirmUserId",
          value: "",
          setHeader: true,
          style: "width:10%",
        },
      ];

      this.$http.url = this.listGasItemUrl;
      this.$http.type = "GET";
      this.$http.param = {
        plantCd: this.workPermit.plantCd,
        // sopWorkTypeCd: 'SWT0000001',
      };
      this.$http.request((_result) => {
        this.useGasItems = [];
        if (this.workPermit.gases && this.workPermit.gases.length > 0) {
          let pushData = [];
          this.$_.forEach(this.workPermit.gases, (gas) => {
            for (let gasValue in gas) {
              let idx = this.$_.findIndex(_result.data, { sopGasId: gasValue });
              let idx2 = this.$_.findIndex(pushData, { sopGasId: gasValue });
              /**
               * idx의 경우 기본적으로 존재하는지 여부를 판단하지만
               *            예전 입력된 값 중 useFlag N처리된 값이 있는 경우는 허용
               */
              if (idx > -1 && gas[gasValue] !== "-" && idx2 === -1) {
                this.$set(_result.data[idx], "me");
                pushData.push(_result.data[idx]);
              }
            }
          });
          if (pushData && pushData.length > 0) {
            this.$_.forEach(pushData, (item) => {
              this.useGasItems.push(item);
              columns.splice(1, 0, {
                // 가스 헤더 적용 로직 추가 필요
                name: item.sopGasId + "_p",
                field: item.sopGasId + "_p",
                label: item.gasName,
                align: "center",
                sortable: false,
                child: [
                  {
                    name: item.sopGasId,
                    field: item.sopGasId,
                    label: item.safetyStandards,
                    align: "center",
                    type: "text",
                    sortable: false,
                    style: "width:" + 50 / pushData.length + "%",
                  },
                ],
              });
            });
          }
        } else {
          let useYList = this.$_.filter(_result.data, (item) => {
            return (
              item.useFlag === "Y" &&
              this.$_.findIndex(item.workTypes, {
                sopWorkTypeCd: "SWT0000001",
              }) > -1
            );
          });
          this.$_.forEach(useYList, (gas) => {
            this.useGasItems.push(gas);
            columns.splice(1, 0, {
              // 가스 헤더 적용 로직 추가 필요
              name: gas.sopGasId + "_p",
              field: gas.sopGasId + "_p",
              label: gas.gasName,
              align: "center",
              sortable: false,
              child: [
                {
                  name: gas.sopGasId,
                  field: gas.sopGasId,
                  label: gas.safetyStandards,
                  align: "center",
                  type: "text",
                  sortable: false,
                  style: "width:" + 50 / useYList.length + "%",
                },
              ],
            });
          });
        }

        this.grid2.columns = columns;
      });
    },
    getEquipRents() {
      if (!this.isOld) {
        this.$http.url = this.listEquipRentUrl;
        this.$http.type = "GET";
        this.$http.param = {
          plantCd: this.workPermit.plantCd,
        };
        this.$http.request((_result) => {
          this.workPermit.equipRents = this.$_.map(_result.data, (item) => {
            item.editFlag = "C";
            item.regUserId = this.$store.getters.user.userId;
            return item;
          });
        });
      }
    },
    addGas() {
      let pushData = {
        sopGasCheckId: uid(), // 가스농도측정번호
        sopWorkPermitId: this.workPermit.sopWorkPermitId, // 작업허가서 일련번호
        supplementWorkTypeCd: "", // 보충작업구분
        checkTime: "", // 점검시간
        gasCheckMachine: "", // 점검기기명
        gasCheckUserName: "",
        gasCheckUserId: "", // 점검자
        gasConfirmUserName: "",
        gasConfirmUserId: "", // 확인자(입회자)
        regUserId: this.$store.getters.user.userId, // 등록자 ID
        chgUserId: "", // 수정자 ID
        editFlag: "C",
      };
      this.$_.forEach(this.useGasItems, (gas) => {
        this.$set(pushData, gas.sopGasId, "0");
      });

      this.workPermit.gases.push(pushData);
    },
    removeGas() {
      let selectData = this.$refs["gasTable"].selected;
      if (!selectData || selectData.length === 0) {
        window.getApp.$emit("ALERT", {
          title: "LBLGUIDE", // 안내
          message: "MSG0000103", // 제외할 행을 지정하세요.
          type: "warning", // success / info / warning / error
        });
      } else {
        if (!this.workPermit.deleteGasChecks)
          this.workPermit.deleteGasChecks = [];
        if (!this.workPermit.deleteGasCheckVals)
          this.workPermit.deleteGasCheckVals = [];
        this.$_.forEach(selectData, (item) => {
          if (
            this.$_.findIndex(this.workPermit.deleteGasChecks, {
              sopGasCheckId: item.sopGasCheckId,
            }) === -1 &&
            item.editFlag !== "C"
          ) {
            this.workPermit.deleteGasChecks.push(item);
            this.$_.forEach(this.useGasItems, (gas) => {
              this.workPermit.deleteGasCheckVals.push({
                sopGasCheckId: item.sopGasCheckId,
                sopGasId: gas.sopGasId,
              });
            });
          }
          this.workPermit.gases = this.$_.reject(this.workPermit.gases, item);
        });
        this.$refs["gasTable"].$refs["compo-table"].clearSelection();
      }
    },
    vendorChange(vendorCd, beforeVendorCd, vendor) {
      this.$set(this.workPermit, "bizNo", vendor.bizNo);
      if (this.workPermit.workers && this.workPermit.workers.length > 0) {
        window.getApp.$emit("CONFIRM", {
          title: "LBLCONFIRM",
          // 확인
          message: "MSG0000115",
          // 해당 작업업체별로 지정된 작업자 정보들이 제외됩니다. 진행하시겠습니까?
          type: "info", // success / info / warning / error
          // 확인 callback 함수
          confirmCallback: () => {
            if (!this.workPermit.deleteWorkers) {
              this.workPermit.deleteWorkers = [];
            }
            this.$_.forEach(
              this.$_.filter(this.workPermit.workers, {
                vendorCd: beforeVendorCd,
              }),
              (item) => {
                if (
                  this.$_.findIndex(this.workPermit.deleteWorkers, {
                    sopWorkerId: item.sopWorkerId,
                  }) === -1
                ) {
                  this.workPermit.deleteWorkers.push(item);
                }
              },
            );
            this.workPermit.workers = this.$_.reject(this.workPermit.workers, {
              vendorCd: beforeVendorCd,
            });
          },
          // 취소 callback 함수
          cancelCallback: () => {
            this.$set(this.workPermit, "vendorCd", beforeVendorCd);
          },
        });
      }
    },
    contentsField(props, col) {
      /**
       * 안전조치사항 항목에서 항목 입력 타입이 '테이블_점검자' 인 경우 테이블에 표시
       * 단, 예전에 '테이블_점검자'였으며 그럼으로 인해 데이터가 저장이 된적이 있는 경우 컴포넌트 표시
       */
      let returnVal = true;
      if (col.name === "confirmUserName") {
        returnVal =
          props.row["sopCheckItemKindCd"] === "SCIK000005" ||
          Boolean(props.row["confirmUserName"]);
      }
      return returnVal;
    },
    tableDataChange(props, col) {
      if (col.name === "necessaryFlag" && props.row[col.name] !== "Y") {
        this.$set(props.row, "confirmFlag", "N");
      }
    },
    datachange(props) {
      if (props.row["editFlag"] !== "C") {
        props.row["editFlag"] = "U";
        props.row["chgUserId"] = this.$store.getters.user.userId;
      }
    },
  },
};
</script>
<style lang="sass">
.gas-item
  padding-top:18px !important
  .q-field__inner
    padding-bottom: 0px !important
  .customText
    padding-bottom: 0px !important
.gas-card-title
  font-size: 15px
  font-weight: 800
</style>
